<template>
    <div>
        <div class="form-footer">
            <p>
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAXCAYAAADpwXTaAAADgUlEQVQ4T42VbWgcVRSG33Pv7EyyFROrgmnwo2pRtDai2FgxupW0m2130x8SodSPrh8VlBpQBP8JKoqgWPrLEONii1gS8AvtlkxiU6oQTFqLNo0UFQ1aKRG01GyyM/feI3M3G91ks3X+Dfec5573nPfMEP7H055L3TmUzY9eKJRqBSRyiTqP6l+jmPOUDtQrfjb/cq34ZWGb39m6lly8RY5sZ6VBQsAo874O5XPDT3x6thp0CaytJ9lUH5e7BEQ3BF1iQr2QJ10HRukftOFXhVD9gw8PzvwXSpEUyQ3XOgjXsKAkYLZJN7bKKA02vKQAkgQiAaPNBIg+YqOPEuupAMHPlNqXudeQGQTgCimjm6tCFlMjaDkehKJgkaT2vo67ZUwerVbFhaZnzwkgIhBEG3W817mOWY8xsYulqip4DIYyGpIEBInSWdR1w2Fo5B3Utj/ZVK/lSRK0slZ1hhmCCKk19+C7s6cxde6MBZKgCPbn3zpcS139Xe65QuE4SdzMulQaM0OzgSOkfY9AAGP7LWlsu/E+fHZ6BPtOfGLPo94Zxaec83ybtUYyt7WfPNllAmVBK9x6NF98BSanf5yXUwKlb0hg7LeT6D3Wj0Iwa3slXAe6qD70swfvt7BNuS3djufs0YGyPXmwpRPt121A7/gAvpw6hh3rOpGZB/WMH8BMMAdHlHomPQdhMXx+aGf+DQvb2JducR3+msGuNgarG5vx9PoduMhbge+nf8Ltq27CN79P4u2xA5gJZxfkW5qA4hAb/McOjltY4nDCif0S/0o6cn3ks0CHuKaxGbtbH8LVjU0Y/fVblCqqBAkn8qU60RCfah14YCJYWKfNudRuWRfbq4vKXhgBr195FRKrWzEwcQjnizOVFc1LVIF+wX/k89fLLrHJiZ7EZa4XP06SrixP1bCxk4wsENmiYg9Llpg2Xnirv90/UwErDSL9rFMn3ixXV2sDosarYviSvzP/Yjmu4rpMTyY+5+ovpCdbTfDv12IxtNQrPRmwe9dI9uO/qsKs5/anW8B6GCQuLctdLI+AglZmi/9o/kjFWTUpG/s6Ot2Y/ACC4qzMQki0OiSENqHaNZjNv7s4d/kvbS6VEVL0wZGXR5thpTHPGqW7h7L53mpF1PwHWDO7vIekTLDSp0ygn/EfPzS83GBqwqKk1N6UpxtoUzBXGB15cuSPWhP+B4iejPMMLGohAAAAAElFTkSuQmCC" alt="">
                <span>Book with confidence. <a href="#" @click.prevent="$root.emit('showBookingGuarantee')">View our Best Price Guarantee</a></span>
            </p>
        </div>
        <div v-if="!isMicrosite" class="form-footer visible-xs visible-sm">
            <trustpilot-widget theme="light"/>
        </div>
        <div v-if="rental === 'long'" class="post-form hidden-xs hidden-sm">
            <p>Got questions about this space? <a href="#" @click.prevent="$bus.$emit('showSpaceContactModal', spaceId)">Contact us</a></p>
        </div>
    </div>
</template>

<script>
    import Microsite from '../../mixins/Microsite';
    import TrustpilotWidget from '../../TrustpilotWidget';

    export default {
        name: 'form-footer',

        components: { TrustpilotWidget },

        mixins: [Microsite],

        props: {
            spaceId: {
                type: Number,
                default() {
                    return null;
                },
            },

            rental: {
                type: String,
                default() {
                    return '';
                },
            },
        },
    };
</script>

<style lang="less" scoped>
    @import (reference) "~assets/less/variables";

    .form-footer {
        text-align: center;
        margin-top: 15px;
        margin-bottom: 5px;
        padding: 0 10px;
        font-size: 0.9em;
        img {
            height: 20px;
            margin-bottom: 2px;
        }
        p {
            &:last-child {
                margin: 0;
            }
            > * {
                display: inline-block;
                vertical-align: middle;
            }
        }
        a {
            color: @YPS-secondary;
            font-weight: 600;
        }
    }
</style>
